import { apiV2 } from '../services/apiV2';
/**
 * Extract chat username from Telegram invite URL
 * Supports both t.me and telegram.me formats
 * @param inviteUrl - Telegram invite URL
 * @returns Chat username without @ symbol, or null if invalid
 */
export const extractUsernameFromInviteUrl = (inviteUrl) => {
    try {
        const url = new URL(inviteUrl);
        // Handle t.me and telegram.me domains
        if (!['t.me', 'telegram.me'].includes(url.hostname)) {
            return null;
        }
        // Extract username from path (remove leading slash)
        const username = url.pathname.slice(1);
        // Validate username format (5-32 characters, start with letter)
        if (!/^[a-zA-Z][a-zA-Z0-9_]{4,31}$/.test(username)) {
            return null;
        }
        return username;
    }
    catch {
        return null;
    }
};
/**
 * Check if Zealy bot is present in a Telegram chat with admin rights
 * @param username - Telegram chat username (without @)
 * @returns Promise with bot status information
 */
export const getTelegramBotStatus = async (username) => {
    const response = await apiV2.telegram.getBotStatus({
        params: { username },
    });
    if (response.status !== 200) {
        throw new Error(`Failed to get bot status: ${response.status}`);
    }
    return response.body;
};
export const generateBotInviteUrl = (channel, botUsername) => {
    const target = channel.startsWith('@') ? channel : channel;
    return `https://t.me/${botUsername}?startchannel=${encodeURIComponent(target)}&admin=post_messages`;
};
